import { render } from "./Chart.vue?vue&type=template&id=714cbf6a"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"
script.render = render

export default script